import { Action } from '@ngrx/store';

import { UserPreferencesState } from '../shared-state.interface';
import { UserPreferencesActions, UserPreferencesActionTypes } from './user-preferences.actions';

export const emptyPreferencesState: UserPreferencesState = {
    userPreferences: undefined
};

export const initialPreferencesState: UserPreferencesState = emptyPreferencesState;

export function userPreferencesReducer(state = initialPreferencesState, action: Action): UserPreferencesState {
    const specificAction: UserPreferencesActions = action as UserPreferencesActions;

    switch (specificAction.type) {
        case UserPreferencesActionTypes.Set:
            return { ...state, userPreferences: specificAction.payload };

        case UserPreferencesActionTypes.Unset:
            return { ...emptyPreferencesState };

        default:
            return state;
    }
}
